<template>
  <section v-if="users">
    <v-container fluid grid-list-md>
      <page-title :title="$t('utenti.title')" />
      <v-layout row wrap class="mt-4">
        <v-flex xs12 sm6 md4 lg3 xl4>
          <v-text-field
            v-model="searchWhat"
            clearable
            :label="$t('utenti.list.cerca')"
            type="text"
            @keyup.native.enter="search"
          />
        </v-flex>
        <v-flex xs12 sm6 md4 lg2 xl2>
          <v-btn color="primary" @click="search" :disabled="!searchWhat">
            <v-icon>search</v-icon> {{ $t('utenti.list.cta1') }}
          </v-btn>
          <v-btn @click="resetSearch" v-if="hasSearched"> <v-icon>undo</v-icon> {{ $t('utenti.list.cta2') }} </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs12>
          <v-list three-line>
            <template v-for="(user, index) in users">
              <v-divider v-if="index > 0" inset :key="index" />
              <v-list-tile :key="user.user_id" avatar @click="editUser(user)">
                <v-list-tile-avatar>
                  <img :src="user.picture" />
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ user.nickname }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ user.email }}</v-list-tile-sub-title>
                  <v-list-tile-sub-title>
                    <user-status :enabled="user.app_metadata ? user.app_metadata.enabled : false" />
                    <span v-if="user.app_metadata">
                      <v-chip
                        flat
                        v-for="(role, index) in user.app_metadata.roles"
                        :key="index"
                        color="blue-grey darken-1"
                        text-color="white"
                        small
                      >
                        <v-icon size="10" class="ml-0 mr-2" v-if="role === 'admin'"
                          >fas fa-crown</v-icon
                        >
                        {{ role }}
                      </v-chip>
                    </span>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text class="text-xs-right"
                    ><strong>{{ $t('utenti.list.accesso') }}</strong><br />{{ user.last_login | formatDate }} alle
                    {{ user.last_login | formatDate('HH:mm') }}</v-list-tile-action-text
                  >
                  <v-list-tile-action-text>{{
                    user.identities[0].connection
                  }}</v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
            </template>
          </v-list>
        </v-flex>
      </v-layout>
      <v-layout row wrap class="mt-4">
        <v-flex xs12>
          <v-btn
            outline
            color="secondary"
            class="secondary ml-0"
            v-if="users.length < total"
            @click="getUsers(true)"
          >
            <v-icon small>add</v-icon> {{  $t('utenti.list.mostra') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </section>
</template>
<script>
import { $EventBus } from '@/eventBus';
import pageTitle from '@/components/common/PageTitle';
import userStatus from '@/components/users/UserStatus';
import _union from 'lodash/union';
export default {
  data: () => ({
    hasSearched: null,
    searchWhat: null,
    users: null,
    perPage: 20,
    page: 0,
    total: null,
  }),
  components: {
    pageTitle,
    userStatus,
  },
  methods: {
    getUsers(loadMore) {
      this.$http
        .get('/users', {
          params: {
            what: this.searchWhat,
            perPage: this.perPage,
            page: this.page,
          },
        })
        .then((response) => {
          if (!loadMore) {
            this.users = response.data.users; // lista
          } else {
            this.users = _union(this.users, response.data.users); // appendi
          }
          this.total = response.data.total;
          this.page++;
        })
        .catch((err) => {
          console.error(err);
          $EventBus.$emit('message', { type: 'error', text: this.$t('error.users.list') });
        });
    },
    resetSearch() {
      this.hasSearched = null;
      this.page = 0;
      this.searchWhat = null; // azzera tutto
      this.getUsers();
    },
    search() {
      this.page = 0; // riparti sempre dalla prima pagina
      this.getUsers();
      this.hasSearched = true; // per mostrare il reset
    },
    editUser(user) {
      this.$router.push({ name: 'userItem', params: { id: user.user_id } });
    },
  },
  mounted() {
    this.getUsers();
  },
};
</script>
